import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  EQueryParameters,
  fetchGetCpdRegions,
  TGetCpdRegionsResponse,
} from '../../../repositories/cpd/v2/get-cpd-regions';
import type { IRegion } from '../../../repositories/cpd/entities/region/Region';
import { HttpBadStatusCodeError } from '@cian/peperrors';
import { EDealType } from '../../../repositories/cpd/entities/v1_create_cpd_draft/PublicV1CreateCpdDraftRequest';
import { IThunkApi } from '../../../types/referral/store';

export const getRegions = createAsyncThunk<IRegion[], EDealType, IThunkApi>(
  'form/getRegions',
  async (dealType, _thunkApi) => {
    const {
      extra: { httpApi, logger },
    } = _thunkApi;

    try {
      const res = (await fetchGetCpdRegions({
        httpApi,
        parameters: {
          dealType: dealType as unknown as EQueryParameters,
        },
      })) as TGetCpdRegionsResponse;

      if (res.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode: res.statusCode,
          domain: 'getRegions.ts',
          message: res.response.message,
        });
      }

      return res.response.regions;
    } catch (e) {
      logger.debug('Ошибка загрузки списка доступных регионов', {
        message: e.message,
        domain: e.domain,
      });

      return [];
    }
  },
);
